<footer class="site-footer">
  <div class="footer-row">
    <div class="footer-brand">
      <a class="footer-admin-link" routerLink="/admin" [attr.aria-label]="'footer.adminAccess' | translate">
        <img class="footer-logo" src="/img/pokemon-go-laval-logo.webp" alt="" width="34" height="34" />
      </a>
      <span class="footer-copyright">
        {{ 'footer.copyrightPrefix' | translate }}
        <a class="footer-company" href="https://azuken.fr" target="_blank" rel="noopener">
          {{ 'footer.company' | translate }}
        </a>
        {{ 'footer.copyrightSuffix' | translate: { endYear: currentYear } }}
        {{ 'footer.allRightsReserved' | translate }}
      </span>
    </div>
    <nav class="footer-links">
      @for (link of links; track link.routeKey) {
        <a [routerLink]="link.routeKey | localizedLink">{{ link.labelKey | translate }}</a>
      }
    </nav>
  </div>
</footer>
